<template>

    <iframe type="text/html" :src="url" width="100%" height="100%" style="overflow: auto; border: 1px ridge blue">
    </iframe>

</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      url: ""
    };
  },
  created() {
    console.log("Created")
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.get("url");

    this.url = "https://" + url;
  },
  mounted() {
    this._auditMessageHandler = (event) => {
      if (!event.data || event.data.type !== 'lcs-audit') return;
      const { eventType, resourceType, resourceId, resourceDescription, category } = event.data;
      api.logAudit(eventType, resourceType, resourceId, resourceDescription, category);
    };
    window.addEventListener('message', this._auditMessageHandler);
  },
  beforeDestroy() {
    window.removeEventListener('message', this._auditMessageHandler);
  }
}
</script>

<style scoped>

</style>
